import { cfiPairFromCfiRange } from "../CfiUtils";

export enum AnnotationType {
  Bookmark = "bookmark",
  Highlight = "highlight",
  Note = "note",
}

export interface Annotation {
  type: AnnotationType;
  location: string;
  /** Text excerpt the annotation refers to (the highlighted/bookmarked text). */
  text?: string;
  /** Highlight color in hex; present on notes/highlights. */
  color?: string;
  /** Present on notes/highlights; highlights have an empty/absent note. */
  note?: string | null;
}

export type AnnotationOverlaps = {
  [AnnotationType.Bookmark]: Annotation | null;
  [AnnotationType.Highlight]: Annotation | null;
  notes: Annotation[];
};

export const isAnnotationHighlight = (annotation?: Annotation): boolean => {
  return !annotation?.note;
};

export const isAnnotationNote = (annotation: Annotation): boolean => {
  if (!annotation.note) return false;
  return annotation.note.length > 0;
};

export const isPointNote = (note: Annotation): boolean => {
  const { start, end } = cfiPairFromCfiRange(note.location);
  return start === end && isAnnotationNote(note);
};

export const getAnnotationLabel = (type: AnnotationType) => {
  return String(type[0]).toUpperCase() + String(type).slice(1);
};

export function toBookmarkAnnotation(bookmark: any): Annotation {
  return {
    ...bookmark,
    type: AnnotationType.Bookmark,
  };
}

export function toNoteAnnotation(note: any): Annotation {
  const annotation: Annotation = { ...note, type: AnnotationType.Note };
  annotation.type = isAnnotationHighlight(annotation)
    ? AnnotationType.Highlight
    : AnnotationType.Note;
  return annotation;
}
